import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Mail } from 'lucide-react';
import AppIcon from '../components/AppIcon';
import { getErrorMessage } from '../api/errors';
import { authService } from '../services';
import {
  clearPendingVerifyEmail,
  isExpiredVerificationTokenError,
} from '../utils/emailVerification';

export default function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const [loading, setLoading] = useState(Boolean(token));
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (!token) {
      setError('Doğrulama bağlantısı geçersiz veya eksik.');
      setLoading(false);
      return;
    }

    let cancelled = false;

    void (async () => {
      try {
        const result = await authService.verifyEmail(token);
        if (!cancelled) {
          clearPendingVerifyEmail();
          setMessage(result.message);
        }
      } catch (err) {
        if (!cancelled) {
          setError(getErrorMessage(err, 'E-posta doğrulanamadı.'));
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [token]);

  const tokenExpired = isExpiredVerificationTokenError(error);

  return (
    <div className="container auth-page">
      <div className="auth-card">
        <div className="auth-header">
          <span className="auth-icon">
            <AppIcon icon={Mail} size={40} />
          </span>
          <h1>E-posta Doğrulama</h1>
        </div>

        {loading && <p className="auth-status">E-posta adresiniz doğrulanıyor...</p>}

        {!loading && message && (
          <>
            <div className="auth-success">{message}</div>
            <Link to="/login" className="btn btn-primary btn-lg btn-block">
              Giriş Yap
            </Link>
          </>
        )}

        {!loading && error && (
          <>
            <div className="auth-error">{error}</div>
            {tokenExpired ? (
              <Link to="/auth/verify-email-pending" className="btn btn-primary btn-lg btn-block">
                Yeni Doğrulama E-postası İste
              </Link>
            ) : (
              <>
                {!token && (
                  <Link to="/auth/verify-email-pending" className="btn btn-outline btn-lg btn-block">
                    Doğrulama E-postası İste
                  </Link>
                )}
                <Link to="/login" className="btn btn-outline btn-lg btn-block">
                  Giriş Sayfasına Dön
                </Link>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
}
